import { GroupSelect } from "../../../../components/invoice/group-select";
import { getLS } from "../../../../utils/useLS";
import { createStateContext } from "react-use";
import React, { useEffect } from "react";
import { useState } from "react";
import ProductsGrid from "../../../../components/invoice/item-grid";
import SearchBox from "../../../../components/invoice/search-box";
import { colors, Divider, Grid, Paper, Typography } from "@material-ui/core";
import GroupLists from "./GroupLists";
import RestItems from "./RestItems";

export const [useSharedGroupId, SharedGroupIdProvider] = createStateContext(-1);

export function RestProducts(props) {
    const { dataTable,groups,groupsSub } = props;
    const locSto = getLS("sto", {});

    const [groupId, setGroupId] = useState(-1);
    const [subGroupId, setSubGroupId] = useState(-1);
    const [GroupColor, setGroupColor] = useState({...groups[0],color:colors.blue[300]});
    const [group, setGroup] = useState({});

    const [subGroups, setSubGroups] = useState([]);


    const onRowClick = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        setGroupColor({...row,color:colors.blue[300]});
        setSubGroups([]);

        const subs = groupsSub?.filter((g) => g.parentId == row.id);
        setSubGroups(subs);
        setGroup(row);

        if (subs?.length > 0){ 
            setSubGroupId(subs[0]?.id);
            setGroup(row);
        }
        else {
            setSubGroupId(row.id);
            setGroup(row);
        }

    };
    const onRowClickSub = (row) => {
        setGroupId(row.id);
        setGroupId(row.id);
        let clickColor=8421504;
        setGroupColor({...row,color:colors.blue[300]});
        setSubGroupId(row.id);
        setGroup(row);

    };
    useEffect(() => {
    }, [subGroupId, dataTable]);
    return (
        <React.Fragment>
            <Paper
                style={{
                    // backgroundColor: colors.green[50],
                    maxHeight: 600,
                    overflow: "auto",
                }}
            >
                <div >

                    <Typography
                        component="div"
                        style={{ direction: "rtl" }}
                    >

                        <Grid item xs={12} container spacing={0} >

                            <Grid item lg={2} md={2} sm={4} xs={3}>
                                <SharedGroupIdProvider>
                                    <GroupLists
                                    groups={[...groups]}
                                    onRowClick={onRowClick}
                                    isMain={true}
                                    GroupColor={GroupColor}

                                    />
                                    <Divider />

                                </SharedGroupIdProvider>
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={3}>
                                <SharedGroupIdProvider>
                                    <GroupLists
                                    groups={[...subGroups]}
                                    onRowClick={onRowClickSub}
                                    isMain={false}
                                    GroupColor={GroupColor}

                                    />
                                  
                                   
                                </SharedGroupIdProvider>
                            </Grid>

                            <Grid item lg={8} md={8} sm={8} xs={3}>
                                <SharedGroupIdProvider>
                                    {/* <SearchBox /> */}


                                    <RestItems
                                        onSelectItem={props.onSelectItem}
                                        values={dataTable}
                                        groupId={subGroupId}
                                        BefrowDataCurrencie={null}
                                        group={group}
                                    />
                                </SharedGroupIdProvider>
                            </Grid>

                        </Grid>
                    </Typography>
                </div>
            </Paper>
        </React.Fragment>
    );
}
